import SSIAP1 from '../Assets/ssiap1mini.png'
import SSIAP2 from '../Assets/ssiap2mini.png'
import SSIAP3 from '../Assets/ssiap3mini.png'
import { TheNav, Fotter } from './Home'

export const SSIAPS = () =>{
    return(
        <div className='h-fit pt-[14vh] md:pb-[8vh] pb-[3vh] md:px-[100px] px-[40px] flex flex-col justify-between items-center'>
            <h3 className='font-bold text-4xl mb-8 text-center font-times'>Nos formations SSIAP</h3>
            <div className='h-5/6 w-full flex justify-evenly items-center my-3 flex-wrap'>
                <a href='/SSIAP1Page' className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3'>
                    <img src={SSIAP1} alt="Photo SSIAP" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formations SSIAP1</h5>
                        <p className='text-center mt-1 px-3'>Devenez agent de sécurité incendie qualifié.</p>
                    </div>
                </a>
                <a href="/SSIAP2Page" className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-8 flex flex-col justify-around items-center my-3'>
                    <img src={SSIAP2} alt="Photo APS" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formations SSIAP2</h5>
                        <p className='text-center mt-1 px-3'>Devenez chef d'équipe service de securité incendie</p>
                    </div>
                </a>
                <a href="/SSIAP3Page" className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-8 flex flex-col justify-around items-center my-3'>
                    <img src={SSIAP3} alt="Photo SST" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formations SSIAP3</h5>
                        <p className='text-center mt-1 px-3'>Devenez chef de service de securité incendie</p>
                    </div>
                </a>
            </div>
        </div>
    );
}

export const SSIAP = () =>{
    return(
        <>
            <TheNav/>
            <SSIAPS/>
            <Fotter/>
        </>
    );
}